require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-financial-center-receives-national-award-for-adult-financial-education-from.json") })
        }
      }, "path---es-articles-financial-center-receives-national-award-for-adult-financial-education-from");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-financial-center-receives-national-award-for-adult-financial-education-from!./.cache/json/es-articles-financial-center-receives-national-award-for-adult-financial-education-from.json
// module id = 2134
// module chunks = 231608221292675